<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Actualizare Emitent Document</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>

    <form [formGroup]="formEmitent">
        <br>
        <h3 class="m-0">Emitent</h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>
        <div class="divider-container">
            <div class="line"></div>
            <span class="text">IDENTIFICARE</span>
            <div class="line"></div>
        </div>

        <div class="row">
            <div [ngClass]="formEmitent.get('id_address_type')?.value !== 4 ? 'col-md-4' : 'col-md-12'">
                <mat-form-field appearance="fill">
                    <mat-label>Tip Persoană/Instituție</mat-label>
                    <mat-select formControlName="id_address_type" (selectionChange)="resetFormEmitent($event.value)">
                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option [value]="1">Cetățean</mat-option>
                        <mat-option [value]="2">Persoană Juridică</mat-option>
                        <mat-option [value]="3">Instituție Extern</mat-option>
                        <mat-option [value]="4">Instituție Intern</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <ng-container *ngIf="formEmitent.get('id_address_type')?.value === -1">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire</mat-label>
                        <input type="text" matInput formControlName="denumire" />
                        <mat-error
                            *ngIf="!formEmitent.controls['denumire'].valid && formEmitent.controls['denumire'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Persoană contact</mat-label>
                        <input type="text" matInput formControlName="pers_contact" />
                    </mat-form-field>
                </div>
            </ng-container>
            <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1 || 
                    formEmitent.get('id_address_type')?.value === 2 ||
                    formEmitent.get('id_address_type')?.value === 3">
                <div class="col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 1">Nume complet -
                            Cetățean</mat-label>
                        <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 2">Căutare:
                            Persoană Juridică => ID: n/a</mat-label>
                        <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 3">Căutare:
                            Instituție Externă => ID: n/a</mat-label>
                        <input matInput [formControl]="entitatiEmitentControl" [matAutocomplete]="autoEntitateEmitent"
                            (change)="onEntitateEmitentChange()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                        <mat-autocomplete #autoEntitateEmitent="matAutocomplete" [displayWith]="displayEntitateEmitent"
                            (optionSelected)="onEntitateEmitentSelected($event.option.value)">
                            <mat-option *ngIf="showEntitatiEmitentMessage" disabled>
                                <span *ngIf="!entitatiEmitentControl.value || entitatiEmitentControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isEntitatiEmitentLoading && entitatiEmitentControl.value && entitatiEmitentControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isEntitatiEmitentLoading && entitatiEmitentLoadComplete && entitatiEmitent.length === 0 && entitatiEmitentControl.value && entitatiEmitentControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let entitate of entitatiEmitent" [value]="entitate">
                                {{ entitate.denumire }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="!formEmitent.controls['denumire_select'].valid && formEmitent.controls['denumire_select'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </ng-container>
        </div>

        <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1">
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>CNP/CIF/Identificator</mat-label>
                        <input type="text" matInput [formControl]="entitatiEmitentByCNPControl"
                            [matAutocomplete]="autoEntitateEmitentByCNP" (change)="onEntitateEmitentByCNPChange()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoEntitateEmitentByCNP="matAutocomplete"
                            [displayWith]="displayEntitateEmitentByCNP"
                            (optionSelected)="onEntitateEmitentByCNPSelected($event.option.value)">
                            <mat-option *ngIf="showEntitatiEmitentByCNPMessage" disabled>
                                <span
                                    *ngIf="!entitatiEmitentByCNPControl.value || entitatiEmitentByCNPControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPLoadComplete && entitatiEmitentByCNP.length === 0 && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let entitate of entitatiEmitentByCNP" [value]="entitate">
                                {{ entitate.cnp_cui }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="!entitatiEmitentByCNPControl.valid && entitatiEmitentByCNPControl.touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="email" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Telefon</mat-label>
                        <input type="text" matInput formControlName="telefon" />
                    </mat-form-field>
                </div>
            </div>

            <div *ngIf="this.entitatiEmitentControl.value?.data_deces || this.entitatiEmitentByCNPControl.value?.data_deces"
                class="warning-label">Emitent decedat!</div>
        </ng-container>

        <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1 ||
                formEmitent.get('id_address_type')?.value === 2 || formEmitent.get('id_address_type')?.value === 3">
            <div class="divider-container">
                <div class="line"></div>
                <span class="text">Sau introduceți/adăugare</span>
                <div class="line"></div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire</mat-label>
                        <input type="text" matInput formControlName="denumire" />
                        <mat-error
                            *ngIf="!formEmitent.controls['denumire'].valid && formEmitent.controls['denumire'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div *ngIf="formEmitent.get('id_address_type')?.value !== 1" class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Persoană contact</mat-label>
                        <input type="text" matInput formControlName="pers_contact" />
                    </mat-form-field>
                </div>

                <div class="row" *ngIf="formEmitent.get('id_address_type')?.value === 2">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>CNP/CIF/Identificator</mat-label>
                            <input type="text" matInput [formControl]="entitatiEmitentByCNPControl"
                                [matAutocomplete]="autoEntitateEmitentByCNP"
                                (change)="onEntitateEmitentByCNPChange()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoEntitateEmitentByCNP="matAutocomplete"
                                [displayWith]="displayEntitateEmitentByCNP"
                                (optionSelected)="onEntitateEmitentByCNPSelected($event.option.value)">
                                <mat-option *ngIf="showEntitatiEmitentByCNPMessage" disabled>
                                    <span
                                        *ngIf="!entitatiEmitentByCNPControl.value || entitatiEmitentByCNPControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPLoadComplete && entitatiEmitentByCNP.length === 0 && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let entitate of entitatiEmitentByCNP" [value]="entitate">
                                    {{ entitate.cnp_cui }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="!entitatiEmitentByCNPControl && entitatiEmitentByCNPControl">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Telefon</mat-label>
                            <input type="text" matInput formControlName="telefon" />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="mb-2">
                <mat-error *ngIf="!formEmitent.get('denumire_select')?.value && !formEmitent.get('denumire')?.value">
                    Câmpul 'Nume complet - Cetățean' sau câmpul 'Denumire' este obligatoriu,
                    deci minim unul din câmpuri de completat.
                </mat-error>
            </div>
            <div *ngIf="formEmitent.get('id_address_type')?.value === 2 ||
                    formEmitent.get('id_address_type')?.value === 3" class="mb-2">
                <mat-error *ngIf="!formEmitent.get('denumire_select')?.value && !formEmitent.get('denumire')?.value">
                    Câmpul 'Căutare: Persoană Juridică/Institutie Externă' sau câmpul 'Denumire' este obligatoriu,
                    deci minim unul din câmpuri de completat.
                </mat-error>
            </div>
        </ng-container>

        <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 4">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Instituție/Direcție</mat-label>
                        <input matInput [formControl]="directiiEmitentControl" [matAutocomplete]="autoDirectiiEmitent"
                            (blur)="onDirectiiEmitentBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoDirectiiEmitent="matAutocomplete" [displayWith]="displayDirectiiEmitent"
                            (optionSelected)="onDirectiiEmitentChange($event.option.value)">
                            <mat-option *ngIf="filteredDirectiiEmitent.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let directie of filteredDirectiiEmitent" [value]="directie">
                                {{ directie.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Compartiment/Departament</mat-label>
                        <input matInput [formControl]="compartimenteEmitentControl"
                            [matAutocomplete]="autoCompartimenteEmitent" (blur)="onCompartimenteEmitentBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoCompartimenteEmitent="matAutocomplete"
                            [displayWith]="displayCompartimenteEmitent"
                            (optionSelected)="onCompartimenteEmitentSelected($event.option.value)">
                            <mat-option *ngIf="showCompartimenteEmitentMessage" disabled>
                                <span
                                    *ngIf="!compartimenteEmitentControl.value || compartimenteEmitentControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isCompartimenteEmitentLoading && compartimenteEmitentControl.value && compartimenteEmitentControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isCompartimenteEmitentLoading && compartimenteEmitentLoadComplete && compartimenteEmitent.length === 0 && compartimenteEmitentControl.value && compartimenteEmitentControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let compartiment of compartimenteEmitent" [value]="compartiment">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Alegeți un operator</mat-label>
                        <mat-select formControlName="user_id"
                            (selectionChange)="onOperatoriEmitentChange($event.value)">
                            <!-- <mat-form-field class="px-2 sticky-input">
                                    <input matInput [formControl]="operatoriEmitentControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field> -->

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let operator of filteredOperatoriEmitent" [value]="operator.id">
                                {{ operator.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="(formEmitent.get('id_address_type')?.value === 1 ||
                formEmitent.get('id_address_type')?.value === 2 ||
                formEmitent.get('id_address_type')?.value === 3)">
            <div class="divider-container">
                <div class="line"></div>
                <span class="text">ADRESĂ/SEDIU</span>
                <div class="line"></div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Țară</mat-label>
                        <input matInput [formControl]="tariEmitentControl" [matAutocomplete]="autoTariEmitent"
                            (blur)="onTariEmitentBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoTariEmitent="matAutocomplete" [displayWith]="displayTariEmitent"
                            (optionSelected)="onTariEmitentChange($event.option.value)">
                            <mat-option *ngIf="filteredTariEmitent.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let tara of filteredTariEmitent" [value]="tara">
                                {{ tara.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Județ</mat-label>
                        <input matInput [formControl]="judeteEmitentControl" [matAutocomplete]="autoJudeteEmitent"
                            (blur)="onJudeteEmitentBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoJudeteEmitent="matAutocomplete" [displayWith]="displayJudeteEmitent"
                            (optionSelected)="onJudeteEmitentChange($event.option.value)">
                            <mat-option *ngIf="filteredJudeteEmitent.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let judet of filteredJudeteEmitent" [value]="judet">
                                {{ judet.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Localitate</mat-label>
                        <input matInput [formControl]="localitatiEmitentControl"
                            [matAutocomplete]="autoLocalitatiEmitent" (blur)="onLocalitatiEmitentBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoLocalitatiEmitent="matAutocomplete"
                            [displayWith]="displayLocalitatiEmitent"
                            (optionSelected)="onLocalitatiEmitentSelected($event.option.value)">
                            <mat-option *ngIf="showLocalitatiEmitentMessage" disabled>
                                <span
                                    *ngIf="!localitatiEmitentControl.value || localitatiEmitentControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isLocalitatiEmitentLoading && localitatiEmitentControl.value && localitatiEmitentControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isLocalitatiEmitentLoading && localitatiEmitentLoadComplete && localitatiEmitent.length === 0 && localitatiEmitentControl.value && localitatiEmitentControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let localitate of localitatiEmitent" [value]="localitate">
                                {{ localitate.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Sector</mat-label>
                        <mat-select formControlName="sector">
                            <mat-option value="-1">--Alegeți--</mat-option>
                            <mat-option value="1">Sector 1</mat-option>
                            <mat-option value="2">Sector 2</mat-option>
                            <mat-option value="3">Sector 3</mat-option>
                            <mat-option value="4">Sector 4</mat-option>
                            <mat-option value="5">Sector 5</mat-option>
                            <mat-option value="6">Sector 6</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4 d-flex flex-row gap-1">
                    <mat-form-field appearance="fill">
                        <mat-label>Stradă</mat-label>
                        <input matInput [formControl]="straziEmitentControl" [matAutocomplete]="autoStraziEmitent"
                            (blur)="onStraziEmitentBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoStraziEmitent="matAutocomplete" [displayWith]="displayStraziEmitent"
                            (optionSelected)="onStraziEmitentSelected($event.option.value)">
                            <mat-option *ngIf="showStraziEmitentMessage" disabled>
                                <span *ngIf="!straziEmitentControl.value || straziEmitentControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isStraziEmitentLoading && straziEmitentControl.value && straziEmitentControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isStraziEmitentLoading && straziEmitentLoadComplete && straziEmitent.length === 0 && straziEmitentControl.value && straziEmitentControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let strada of straziEmitent" [value]="strada">
                                {{ strada.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <button
                        *ngIf="!isStraziEmitentLoading && straziEmitentLoadComplete && straziEmitent.length === 0 && straziEmitentControl.value && straziEmitentControl.value.length >= 2"
                        type="button" class="btn-add-entry" (click)="addStraziEmitent()">
                        <i class="icon fa fa-add"></i>
                    </button>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Bloc</mat-label>
                        <input type="text" matInput formControlName="bloc" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Scară</mat-label>
                        <input type="text" matInput formControlName="scara" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Apartament</mat-label>
                        <input type="text" matInput formControlName="apartament" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Cod Poștal</mat-label>
                        <input type="text" matInput formControlName="cod_postal" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr document deces</mat-label>
                        <input type="text" matInput formControlName="numar_deces" />
                    </mat-form-field>
                </div>
                <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="col-md-4">
                    <mat-form-field>
                        <mat-label>Dată deces</mat-label>
                        <input matInput [max]="today" [matDatepicker]="dateDecesPicker"
                            formControlName="data_deces_input" placeholder="Dacă există..." readonly
                            (focus)="dateDecesPicker.open()" />
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dateDecesPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dateDecesPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-checkbox [ngClass]="formEmitent.get('id_address_type')?.value === 1 ? 'mt-md-2' : 'mb-2'"
                        color="primary" formControlName="person_status">
                        Verificare evidența persoanelor
                    </mat-checkbox>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Observații</mat-label>
                        <textarea matInput formControlName="observatii"
                            placeholder="Dacă există observații..."></textarea>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <div class="row">
            <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="formEmitent.invalid"
                    (click)="submitForm()">
                    Actualizează
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>